import React from 'react'
import styles from './WelcomeMessageStyles'
import { Container, Message, Button } from 'semantic-ui-react'

export default function WelcomeMessage() {
  return (
    <Container textAlign='center'>
      <Message className={styles.message}>
        <Message.Header>Welcome to seekrev!</Message.Header>
        <p>
          Let's select a project or create one by clicking
          <span className={styles.addButton}>
            <Button basic icon='plus' circular size='mini' />
          </span>
          from the left sidebar.
        </p>
      </Message>
      <iframe
        style={{
          borderRadius: 4,
          width : 600,
          height: 400
        }}
        title='Seekrev Tutorial'
        src={`https://www.youtube.com/embed/8xMsrrqljPc?autoplay=1`}
        frameBorder="0"
      />
    </Container>
  )
}



// WEBPACK FOOTER //
// ./src/Pages/Home/WelcomeMessage.js